import { Component, OnInit } from '@angular/core';
import { StudentHistoryDashboard } from '../../models/student-history-dashboard';
import { StudentHistoryService } from '../../services/student-history.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';

@Component({
  selector: 'app-history-dashboard',
  templateUrl: './history-dashboard.component.html',
  styleUrls: ['./history-dashboard.component.scss']
})
export class HistoryDashboardComponent extends ComponentBase implements OnInit {
  public studentHistoryDashboard: StudentHistoryDashboard;
  loading: boolean = true;

  constructor(private studentHistoryService: StudentHistoryService
    , private pageHeadingService: PageHeadingService) {
    super();
  }

  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Student history"));
    let sub = this.studentHistoryService.getHistoryDashboard()
      .subscribe((res) => {
        this.loading = false;
        this.studentHistoryDashboard = res;
      });
    this.addSubscription(sub);
  }

}
